<mat-toolbar class="mt-2">
  <span style="font-size: 16px">Procure Masster Buyer & Supplier User Agreement</span>
  <span class="example-spacer"></span>
  <mat-icon (click)="onNoClick()">highlight_off</mat-icon>
</mat-toolbar>
<hr />
<div class="ms-3">
  <p>
    <b>Procure Masster</b>, herein referred to as “Procure Masster” or “Procuremasster.com,” operates a cloud sourcing platform accessible
    via the website www.procuremasster.com. This platform enables secure sourcing activities, including electronic negotiations and
    communications, between registered Buyer organizations (“Buyers”) and Supplier entities (“Suppliers” or “Vendors”).
  </p>
  <p>
    The <b>ProcureMasster.com Platform </b> encompasses modules for <b>Request for Quotation (RFQ), Reverse Auctions, Forward Auctions</b>,
    and <b>Get New Vendor /Localization </b>(collectively referred to as "Sourcing Events"), tailored for Buyers seeking proposals for goods
    and services or selling goods and services. Buyers, as event Hosts, issue secure requests to Suppliers/Participants, who can
    subsequently access and partake in Sourcing Events by submitting Bids (“Bids”) or Quotation Information (“Quotations”) through the
    platform.
  </p>
  <p>
    <b>Procure Masster</b> provides this platform strictly as an sourcing tool for negotiation and supplier discovery. Procure Masster
    assumes no responsibility for payment collections, contract execution, or the fulfilment of transactions resulting from Sourcing Events
    conducted through the platform. These responsibilities rest solely with the respective Buyer and Supplier parties.
  </p>
  <p>
    By registering as a <b>Buyer</b> or <b>Supplier/Vendor</b> on Procure Masster, you affirm that you have read, understood, and agree to
    be legally bound by the terms and conditions set forth in this Agreement (“Terms”). All individuals providing information on behalf of
    Buyer or Supplier entities represent that they are duly authorized to act on behalf of their respective organizations.
  </p>

  <h6>1. SERVICE AGREEMENT FOR BUYERS & SUPPLIERS</h6>
  <h6>1.1 Buyer Registration</h6>
  <p>
    Registration as a Buyer requires prior approval from the Procure Masster team. Suppliers/Vendors must register as free members by
    completing the online registration process to access or participate in RFQ or Auction events. Suppliers are obligated to ensure the
    accuracy of their profile information and to update it as required.
  </p>
  <h6>1.2 Platform Usage Fees</h6>
  <p>
    Buyers & Supplier will be charged fees for hosting RFQ and Auction events as per the pricing published on the Procure Masster website.
  </p>
  <h6>1.3 Confidentiality of Login Credentials</h6>
  <p>
    Users must maintain the confidentiality of their login credentials. User licenses are strictly non-transferable and tied to specific
    email addresses and contact details. Sharing login credentials within or outside the organization constitutes a serious breach of
    security and may result in immediate suspension or termination of access.
  </p>
  <h6>1.4 Liabilities and Indemnities</h6>
  <p>
    Buyers acknowledge that the execution of Sourcing Events on Procure Masster is their sole responsibility. Procure Masster bears no
    liability for third-party claims arising from Buyer-hosted events. Buyers agree to indemnify and hold harmless Procure Masster from any
    such claims. Suppliers agree that their participation in any RFQ or Auction event signifies compliance with the terms and criteria set
    forth by the Buyer.
  </p>
  <h6>1.5 Bid Withdrawal and Event Completion</h6>
  <p>
    Suppliers are prohibited from withdrawing bids during an active Auction event. In the case of RFQs,Suppliers may modify submissions
    until the closing date. Erroneous bids during Auctions may only be corrected by the Buyer. Violation of these rules may constitute a
    breach of contract, exposing Suppliers to potential legal action and possible termination of registration on Procure Masster.
  </p>

  <h6>1.6 Event Outcomes and Obligations</h6>
  <p>
    Buyers retain full discretion over supplier selection and contract award decisions. Procure Masster plays no role in evaluating or
    enforcing Sourcing Event outcomes. Additionally, Procure Masster assumes no responsibility for pre- or post-event communications or
    contractual arrangements between Buyers and Suppliers.
  </p>
  <h6>1.7 Platform Neutrality</h6>
  <p>
    Procure Masster neither engages in the sale or purchase of goods nor guarantees the quality, legality, or financial security of goods or
    services exchanged via the platform. All Buyers and Suppliers are required to independently validate and audit each other’s credentials
    before engaging in transactions.
  </p>
  <h6>2. SUPPORT & TRAINING</h6>
  <p>
    2.1 Procure Masster offers training and technical support via live chat, tutorials, user manuals, and email or phone assistance. This
    support is limited to authorized users participating in Sourcing Events.
  </p>
  <p>
    2.2 Buyers may purchase monthly or annual licenses, which allow access to platform services. Buyer licenses are non-transferable and
    valid solely for the registered organization. Additional consultancy services may be provided for a fee, subject to a signed agreement.
  </p>
  <h6>3. LICENSE FEES & PAYMENTS</h6>
  <p>
    3.1 License fees are detailed on the Procure Masster website and must be prepaid. Annual licenses cover 12 months from the date of
    acceptance. Refunds are not permitted post-acceptance.
  </p>
  <h6>4. DISCLAIMER</h6>
  <p>
    Procure Masster serves solely as a facilitator for sourcing events and bears no liability for disputes arising between Buyers and
    Suppliers. The platform does not validate the authority or creditworthiness of its users. Users participate at their own risk and bear
    sole responsibility for their interactions and agreements.
  </p>
  <h6>5. CONTRACT TERMINATION></h6>
  <p>
    Procure Masster reserves the right to terminate this agreement for non-payment, breach of terms, or misuse of the platform. Upon
    termination, all access to the platform ceases, and data related to terminated accounts will be managed in accordance with Procure
    Masster’s data retention policies.
  </p>
  <h6>6. CONFIDENTIALITY</h6>
  <p>
    All information shared on Procure Masster is confidential and must not be disclosed to third parties without prior consent. Both Buyers
    and Suppliers agree to enforce confidentiality measures within their organizations.
  </p>
  <h6>7. GOVERNING LAW & JURISDICTION</h6>
  <p>
    This Agreement is governed by the laws of Maharashtra , India. Any disputes shall be exclusively resolved in the courts of Pune
    District.
  </p>
</div>
